








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Switcher extends Vue {
  @Prop({ default: () => [] }) public options!: any[];
  @Prop({ default: () => null }) public value!: any;

  public $refs!: {
    tracker: HTMLElement;
    switcher: HTMLElement;
  };

  public trackerStyles: any = {
    left: '-1px',
    width: '50px',
  };

  public classList: any = {
    'use-animations': false,
  };

  public activate($event: any, option: any, emit: boolean = true) {
    const target = $event.target;

    const buttonLeft = target.offsetLeft === 0 ? -2 : target.offsetLeft;
    const buttonWidth = target.offsetWidth + 2;

    this.trackerStyles.left = `${buttonLeft}px`;
    this.trackerStyles.width = `${buttonWidth}px`;

    if (emit) {
      this.$emit('onChange', option.id);
    }
  }

  public mounted() {
    const selectedValue = this.value ? this.value : this.options[0].id;
    const btn = this.getButton(selectedValue);

    if (btn) {
      this.activate(
        {
          target: btn,
        },
        { id: selectedValue },
        false,
      );
    }

    setTimeout(() => {
      this.classList['use-animations'] = true;
    });
  }

  private getButton(id: string) {
    const buttons = this.$refs.switcher.getElementsByClassName('btn');

    for (const button of buttons) {
      if (button.getAttribute('dataid') === id) {
        return button;
      }
    }
  }
}
